// Public no-auth API client for the citizen MajheKTCL webapp
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const PUBLIC_API_BASE = `${BACKEND_URL}/api/public`;

export const publicApi = axios.create({ baseURL: PUBLIC_API_BASE });
